import React from 'react';
import './PostCard.css';

const ACCENTS = ['olive', 'ochre', 'brick'];

const PostCard = ({ post, index = 0 }) => {
  const accent = post.pinned ? 'brick' : ACCENTS[index % 2 === 0 ? 1 : 0];
  const dateStr = post.date
    ? new Date(post.date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
    : '';

  return (
    <article className="pin-card post">
      <span className={'pin ' + accent}></span>
      <div className="post-top">
        {post.pinned
          ? <span className="badge"><span className="badge-dot"></span>Pinned</span>
          : <span className={'badge ' + accent}><span className="badge-dot"></span>Notice</span>
        }
        {dateStr && <span className="post-date">{dateStr}</span>}
      </div>
      <h3>{post.title}</h3>
      {post.body && <p>{post.body}</p>}
    </article>
  );
};

export default PostCard;
